import { Check } from "lucide-react";
import React from "react";

interface CustomInputSkillProps {
	groupedSkillIndex: number;
	singleSkillIndex: number;
	onSaveCustomSkillAdded: (groupedSkillIndex: number, singleSkillIndex: number, skillAdded: string) => void;
}

function CustomInputSkill({ groupedSkillIndex, singleSkillIndex, onSaveCustomSkillAdded }: CustomInputSkillProps) {
	const [value, setValue] = React.useState("");

	return (
		<div className="box-border flex h-[38px] w-[150px] items-center justify-between gap-2 rounded-[5px] border border-[#d5dbe1] bg-white px-2 py-[9px]">
			<input
				type="text"
				value={value}
				className="h-5 w-20 rounded border-0 outline-none"
				onChange={(e) => {
					setValue(e.target.value);
				}}
			/>
			<div
				className="flex h-[26px] w-10 cursor-pointer items-center justify-center rounded bg-[#019ce0]"
				onClick={() => {
					onSaveCustomSkillAdded(groupedSkillIndex, singleSkillIndex, value);
				}}
			>
				<Check className="size-4 text-white" />
			</div>
		</div>
	);
}

export default CustomInputSkill;
